// frontend/app/constants/storageKeys.js
//
// A single source of truth for browser-storage key strings (sessionStorage,
// localStorage, AsyncStorage). Components should import a key from here
// rather than inlining the string a second time — a key that only ever
// exists as a literal in one call site cannot drift from itself, but a
// string repeated across files can, silently, the moment one copy is edited
// and the other is not.
//
// Start small: add a key here when you add the storage call that uses it,
// rather than pre-declaring keys nothing reads yet.

export const STORAGE_KEYS = {
  // Whether the lesson workspace's Saras AI rail (LessonSarasPanel) is
  // collapsed. Session-scoped: a teacher who collapsed it to make room for
  // the lesson content should not have it silently reopen on every visit
  // within the same tab, but a fresh tab starts from the default (expanded).
  LESSON_SARAS_PANEL_COLLAPSED: "lesson_saras_panel_collapsed",
};
